import request from '@/config/axios'

export const getCertProofPage = (params: any) =>
  request.get({ url: '/bosscircle/cert-proof/page', params })
export const getCertProof = (id: number) =>
  request.get({ url: '/bosscircle/cert-proof/get', params: { id } })
export const verifyCertProof = (id: number) =>
  request.get({ url: '/bosscircle/cert-proof/verify', params: { id } })
export const revokeCertProof = (data: any) =>
  request.put({ url: '/bosscircle/cert-proof/revoke', data })
